/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Ai_NameInputs */

const en_marketing_feature_ai_name = /** @type {(inputs: Marketing_Feature_Ai_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI assistant`)
};

const es_marketing_feature_ai_name = /** @type {(inputs: Marketing_Feature_Ai_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente de IA`)
};

const fr_marketing_feature_ai_name = /** @type {(inputs: Marketing_Feature_Ai_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant IA`)
};

/**
* | output |
* | --- |
* | "AI assistant" |
*
* @param {Marketing_Feature_Ai_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_ai_name = /** @type {((inputs?: Marketing_Feature_Ai_NameInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Ai_NameInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_ai_name(inputs)
	if (locale === "es") return es_marketing_feature_ai_name(inputs)
	return fr_marketing_feature_ai_name(inputs)
});